import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

//-- Get Meta Collection Types
function getMetaCollectionTypes(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/collection_types/`, oauthTokenHeader);
  }
  
  //-- Create New Meta Collection Types
  function createMetaCollectionTypes(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(
      `${apiUrl}/meta/collection_types/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Edit Meta Collection Types
  function updateMetaCollectionTypes(
    oauthTokenHeader: any,
    data: any,
    collection_types_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/collection_types/${collection_types_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

  //-- Get Meta Collection Methods
function getMetaCollectionMethods(oauthTokenHeader: string) {
    return fetchWrapper.get(
      `${apiUrl}/meta/collection_methods/`,
      oauthTokenHeader
    );
  }
  
  //-- Create New Meta Collection Methods
  function createMetaCollectionMethods(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(
      `${apiUrl}/meta/collection_methods/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Edit Meta Collection Methods
  function updateMetaCollectionMethods(
    oauthTokenHeader: any,
    data: any,
    collection_method_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/collection_methods/${collection_method_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

  //-- Get Meta Format Types
function getMetaFormatTypes(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/format_types/`, oauthTokenHeader);
  }
  
  //-- Create New Meta Format Types
  function createMetaFormatTypes(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(
      `${apiUrl}/meta/format_types/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Edit Meta Format Types
  function updateMetaFormatTypes(
    oauthTokenHeader: any,
    data: any,
    format_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/format_types/${format_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

  //-- Get Meta trafficSource
  function getMetaTrafficSource(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/traffic_sources/`, oauthTokenHeader);
  }
  
  //-- Create New Meta trafficSource
  function createMetaTrafficSource(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(
      `${apiUrl}/meta/traffic_sources/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Update Meta trafficSource
  function updateMetaTrafficSource(
    oauthTokenHeader: any,
    data: any,
    traffic_source_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/traffic_sources/${traffic_source_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

  //-- Get Meta device type
  function getMetaDevices(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/devices/`, oauthTokenHeader);
  }
  
  //-- Create Meta device type
  function createMetaDeviceType(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(`${apiUrl}/meta/devices/`, data, oauthTokenHeader);
  }
  
  //-- Update Meta device type
  function updateMetaDeviceType(
    oauthTokenHeader: any,
    data: any,
    device_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/devices/${device_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

  //-- Get Meta product type
  function getMetaProductTypes(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/products/`, oauthTokenHeader);
  }
  //-- Create new Meta product type
  function createMetaProductTypes(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(`${apiUrl}/meta/products/`, data, oauthTokenHeader);
  }
  //-- Update Meta product type
  function updateMetaProductTypes(
    oauthTokenHeader: any,
    data: any,
    product_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/products/${product_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Get Meta industry type
  function getMetaIndustries(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/industries/`, oauthTokenHeader);
  }
  //-- Create Meta industry type
  function createMetaIndustries(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(
      `${apiUrl}/meta/industries/`,
      data,
      oauthTokenHeader
    );
  }
  //-- Update Meta industry type
  function updateMetaIndustries(
    oauthTokenHeader: any,
    data: any,
    industry_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/industries/${industry_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Get Meta currency type
  function getMetaCurrencies(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/currencies/`, oauthTokenHeader);
  }
  //-- Create Meta currency type
  function createMetaCurrencies(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(
      `${apiUrl}/meta/currencies/`,
      data,
      oauthTokenHeader
    );
  }
  //-- Update Meta currency type
  function updateMetaCurrencies(
    oauthTokenHeader: any,
    data: any,
    currency_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/currencies/${currency_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

  //-- Get Meta Traffic Click Identifiers
  function getMetaTrafficClickIdentifiers(oauthTokenHeader: string) {
    return fetchWrapper.get(
      `${apiUrl}/meta/traffic_click_identifiers/`,
      oauthTokenHeader
    );
  }

  //-- Create Meta Traffic Click Identifiers
  function createMetaTrafficClickIdentifiers(
    oauthTokenHeader: string,
    data: any
  ) {
    return fetchWrapper.post(
      `${apiUrl}/meta/traffic_click_identifiers/`,
      data,
      oauthTokenHeader
    );
  }
  //-- Update Meta Traffic Click Identifiers
  function updateMetaTrafficClickIdentifiers(
    oauthTokenHeader: any,
    data: any,
    traffic_click_identifier_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/traffic_click_identifiers/${traffic_click_identifier_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Get Meta Territory
  function getMetaTerritories(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/territories/`, oauthTokenHeader);
  }
  //-- Create New Meta Territory
  function createMetaTerritories(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(
      `${apiUrl}/meta/territories/`,
      data,
      oauthTokenHeader
    );
  }
  //-- Update Meta Territory
  function updateMetaTerritories(
    oauthTokenHeader: any,
    data: any,
    territory_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/territories/${territory_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Get Meta Organizations
  function getMetaOrganizations(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/organizations/`, oauthTokenHeader);
  }
  //-- Create New Meta Organizations
  function createMetaOrganizations(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(
      `${apiUrl}/meta/organizations/`,
      data,
      oauthTokenHeader
    );
  }
  //-- Update Meta Organizations
  function updateMetaOrganizations(
    oauthTokenHeader: any,
    data: any,
    organization_shared_uid: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/meta/organizations/${organization_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }
  
  //-- Get Meta Geo
  function getMetaGeo(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/geos/`, oauthTokenHeader);
  }
  
  //-- Create New Meta Geo
  function createMetaGeo(oauthTokenHeader: string, data: any) {
    return fetchWrapper.post(`${apiUrl}/meta/geos/`, data, oauthTokenHeader);
  }
  //-- Update Meta Geo
  function updateMetaGeo(oauthTokenHeader: any, data: any, geo_shared_uid: any) {
    return fetchWrapper.put(
      `${apiUrl}/meta/geos/${geo_shared_uid}/`,
      data,
      oauthTokenHeader
    );
  }

  function getTerritories(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/territories/`, oauthTokenHeader);
  }
  
  
  export const metaEntitiesService = {
    getMetaCollectionTypes,
    createMetaCollectionTypes,
    updateMetaCollectionTypes,
    getMetaDevices,
    createMetaDeviceType,
    updateMetaDeviceType,
    getMetaProductTypes,
    createMetaProductTypes,
    updateMetaProductTypes,
    getMetaIndustries,
    createMetaIndustries,
    updateMetaIndustries,
    getMetaCurrencies,
    createMetaCurrencies,
    updateMetaCurrencies,
    getMetaTrafficClickIdentifiers,
    createMetaTrafficClickIdentifiers,
    updateMetaTrafficClickIdentifiers,
    getMetaTerritories,
    createMetaTerritories,
    updateMetaTerritories,
    getMetaOrganizations,
    createMetaOrganizations,
    updateMetaOrganizations,    
    getMetaGeo,      
    createMetaGeo,              
    updateMetaGeo,
    getMetaCollectionMethods,
    createMetaCollectionMethods,
    updateMetaCollectionMethods,
    getMetaFormatTypes,
    createMetaFormatTypes,
    updateMetaFormatTypes,
    getMetaTrafficSource,
    createMetaTrafficSource,
    updateMetaTrafficSource,
    getTerritories
  };